module.exports = __webpack_public_path__ + "img/bands.841f9f25.svg";